import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const TestForms = () => {
  const [results, setResults] = useState([]);

  const addResult = (test, status, details) => {
    setResults(prev => [...prev, { test, status, details, time: new Date().toLocaleTimeString() }]);
  };

  const testBackendConnection = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/debug-info`);
      const data = await response.json();
      addResult('Backend Connection', '✅ Success', JSON.stringify(data, null, 2));
    } catch (error) {
      addResult('Backend Connection', '❌ Failed', error.message);
    }
  };

  const testContactForm = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: 'Test User',
          email: 'test@test.com',
          phone: '876-123-4567',
          message: 'This is a test message with more than 10 characters for validation'
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        addResult('Contact Form', '✅ Success', `ID: ${data.id}`);
      } else {
        addResult('Contact Form', '❌ Failed', JSON.stringify(data, null, 2));
      }
    } catch (error) {
      addResult('Contact Form', '❌ Error', error.message);
    }
  };

  const testQuoteForm = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: 'Test User',
          email: 'test@test.com',
          phone: '876-123-4567',
          service: 'Electrical Installation',
          project_details: 'This is a test project with more than 10 characters'
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        addResult('Quote Form', '✅ Success', `ID: ${data.id}`);
      } else {
        addResult('Quote Form', '❌ Failed', JSON.stringify(data, null, 2));
      }
    } catch (error) {
      addResult('Quote Form', '❌ Error', error.message);
    }
  };

  const testCORS = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contacts`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (response.ok) {
        const data = await response.json();
        addResult('CORS Test', '✅ Success', `Retrieved ${data.length} contacts`);
      } else {
        addResult('CORS Test', '❌ Failed', `Status: ${response.status}`);
      }
    } catch (error) {
      addResult('CORS Test', '❌ Error', error.message);
    }
  };

  const runAllTests = async () => {
    setResults([]);
    await testBackendConnection();
    await new Promise(r => setTimeout(r, 500));
    await testCORS();
    await new Promise(r => setTimeout(r, 500));
    await testContactForm();
    await new Promise(r => setTimeout(r, 500));
    await testQuoteForm();
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <Card className="mb-6">
          <CardHeader>
            <CardTitle>QNC Forms Debug Page</CardTitle>
            <p className="text-sm text-gray-600">
              Backend URL: {process.env.REACT_APP_BACKEND_URL}
            </p>
          </CardHeader>
          <CardContent>
            <div className="flex space-x-4">
              <Button onClick={runAllTests} className="bg-blue-600 hover:bg-blue-700">
                Run All Tests
              </Button>
              <Button onClick={testBackendConnection} variant="outline">
                Test Backend
              </Button>
              <Button onClick={testCORS} variant="outline">
                Test CORS
              </Button>
              <Button onClick={testContactForm} variant="outline">
                Test Contact
              </Button>
              <Button onClick={testQuoteForm} variant="outline">
                Test Quote
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Test Results</CardTitle>
          </CardHeader>
          <CardContent>
            {results.length === 0 ? (
              <p className="text-gray-500">Click "Run All Tests" to start</p>
            ) : (
              <div className="space-y-4">
                {results.map((result, index) => (
                  <div key={index} className="border-l-4 border-gray-300 pl-4 py-2">
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-semibold">{result.test}</span>
                      <span className="text-sm text-gray-500">{result.time}</span>
                    </div>
                    <div className="text-lg mb-1">{result.status}</div>
                    <pre className="text-xs bg-gray-100 p-2 rounded overflow-x-auto">
                      {result.details}
                    </pre>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TestForms;
